import { events } from '../core/events.js';

// Each entry: { id, name, color, count }.
// Items with the same `id` stack; distinct ids are separate cells.
const items = [];

export function getItems() { return items.slice(); }

export function hasItem(id, count = 1) {
  const it = items.find((x) => x.id === id);
  return !!it && it.count >= count;
}

export function countItem(id) {
  const it = items.find((x) => x.id === id);
  return it ? it.count : 0;
}

export function addItem({ id, name, color, count = 1 }) {
  const existing = items.find((x) => x.id === id);
  if (existing) existing.count += count;
  else items.push({ id, name, color, count });
  events.emit('inventory:changed');
  events.emit('inventory:added', { id, count });
}

export function removeItem(id, count = 1) {
  const i = items.findIndex((x) => x.id === id);
  if (i < 0) return false;
  items[i].count -= count;
  if (items[i].count <= 0) items.splice(i, 1);
  events.emit('inventory:changed');
  return true;
}
